import { useTranslation } from '@translations';
import {
    alreadyHasAccount,
    hasExistingProcessInCurrentBank,
    hasNotCompletedKYCForm,
    hasPendingKYCAdvisorReview,
    waitingForApproverParentConsent,
} from '@utils/child-status-utils';
import { useChildCardContext } from '../context';
import { canGiveConsent, canStartNewProcess } from '../utils';

export const ChildCardEligibilityStatus = () => {
    const { childEligibility } = useChildCardContext();
    const { childCard } = useTranslation();

    const getStatusText = () => {
        if (alreadyHasAccount(childEligibility)) {
            return childCard.accountAlreadyExists;
        }

        if (canStartNewProcess(childEligibility)) {
            return childCard.noAsk;
        }

        if (hasExistingProcessInCurrentBank(childEligibility)) {
            if (waitingForApproverParentConsent(childEligibility)) {
                if (canGiveConsent(childEligibility)) {
                    return childCard.needsYourConsent;
                }

                return childCard.waitingForApproverParentConsent;
            }

            if (hasNotCompletedKYCForm(childEligibility) || hasPendingKYCAdvisorReview(childEligibility)) {
                return childCard.incompleteProcess;
            }
        }

        return null;
    };

    const statusText = getStatusText();

    if (statusText) {
        return (
            <p className="child-card__text" data-testid="child-eligibility-status">
                {statusText}
            </p>
        );
    }

    return null;
};
